import { ISiteAdminSettings, ISiteSubscriptionSettings } from '../../../settings/interfaces/ISiteSettingsForSiteAdmin';
import { Request } from './Request';

export interface IUpdateSiteSettingsForSiteAdminParams {
  id: string;
  siteAdminSettings: ISiteAdminSettings;
  subscriptionSettings?: ISiteSubscriptionSettings;
}

export interface IUpdateSiteSettingsForSiteAdminResult {
}

export class UpdateSiteSettingsForSiteAdminRequest extends Request<IUpdateSiteSettingsForSiteAdminParams, IUpdateSiteSettingsForSiteAdminResult> {
  constructor(params: IUpdateSiteSettingsForSiteAdminParams) {
    super('updateSiteSettingsForSiteAdmin', params);
  }
}
